/*
Lodash has an isEmpty but it's only for objects. This library was using it also for numbers which always returns true.
https://github.com/lodash/lodash/issues/496

Here is a little smarter isEmpty that handles non-objects too.
 */
import isObjectLike from "lodash/isObjectLike";
import isEmpty from "lodash/isEmpty";

export default value => {
	const objectLike = isObjectLike(value);
	const empty = isEmpty(value);

	return (objectLike && empty) || (!objectLike && (!value && value !== 0 && value !== false));
};
